import { Body2 } from '@cian/ui-kit';
import React from 'react';

import styles from './TimeLabel.css';

interface ITimeLabelProps {
  added: string;
  humanizedTime: string;
}

export const TimeLabel = (props: ITimeLabelProps) => {
  return (
    <div className={styles['timeLabel']}>
      <div className={styles['relative']}>
        <Body2 color="text-secondary-default">{props.humanizedTime}</Body2>
      </div>
      <div className={styles['absolute']}>
        <Body2 color="text-secondary-default">{props.added}</Body2>
      </div>
    </div>
  );
};
